export class PeriodeSearch {
  constructor (recherchePeriode) {
    this.login = recherchePeriode ? recherchePeriode.login : null
    this.entrepriseId = recherchePeriode ? recherchePeriode.entrepriseId : null
    this.entityId = recherchePeriode ? recherchePeriode.entityId : null
  }
}
